// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { espotAndTestimonialsContainerStyles } from "@tps/App/Widgets/EspotAndTestimonialsContainer/EspotAndTestimonialsContainer";
import { getSystemColor, xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

espotAndTestimonialsContainerStyles.leftSection = {
    css: css`
        width: 50%;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};
espotAndTestimonialsContainerStyles.rightSection = {
    css: css`
        width: 50%;
        ${xScreen("lte", "md")} {
            width: 100%;
        }
    `,
};

espotAndTestimonialsContainerStyles.wrapper = {
    css: css`
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        ${xScreen("lte", "md")} {
            flex-direction: column;
        }
    `,
};

espotAndTestimonialsContainerStyles.container = {
    css: css`
        width: 100vw;
        position: relative;
        left: 50%;
        right: 50%;
        margin-left: -50vw;
        margin-right: -50vw;
        display: flex;
        justify-content: center;
        background: linear-gradient(
            to right,
            ${getSystemColor("primary.main")} 50%,
            ${getSystemColor("common.ui2")} 50%
        );
        ${xScreen("lte", "md")} {
            background: none;
        }
    `,
};
espotAndTestimonialsContainerStyles.page = {
    css: css`
        &&& {
            overflow: visible;
            ${xScreen("lte", "md")} {
                padding-inline: 0;
            }
        }
    `,
};
